// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

import React, { useEffect, useState,useRef } from "react";
import { modelInputProps } from "../helpers/Interfaces";
import AppContext from "./createContext";

type ThingmojiItem = {
  resizedImage: HTMLImageElement,
  originalImage: HTMLImageElement
};

type imageItem = {
  image: string,
  originalImage: string,
  index: number
}

type messageItem = {
texts: string[],
images: imageItem[],
index: number
}
const AppContextProvider = (props: {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
}) => {
  const [clicks, setClicks] = useState<Array<modelInputProps> | null>(null);
  const [selected, setSelected] = useState<Array<modelInputProps> | null>(null);
  const [image, setImage] = useState<HTMLImageElement | null>(null);
  const [maskImg, setMaskImg] = useState<HTMLImageElement | null>(null);
  const [segmentedImage, setSegmentedImage] = useState<HTMLImageElement | null>(null);
  const [isBrushing, setIsBrushing] = useState<boolean>(false);
  const [allThingmoji, setAllThingmoji] = useState<Array<ThingmojiItem> | null>([]);
  //add message and setMessage as a dictionary, with texts=[], images=[], and index=0
  const [message, setMessage] = useState<messageItem | null>({texts:[],images:[],index:0});
  const [thingmoji, setThingmoji] = useState<ThingmojiItem | null>(null);
  const intervalthingmoji = useRef<any>(null);

  return (
    <AppContext.Provider
      value={{
        clicks: [clicks, setClicks],
        selected: [selected, setSelected],
        image: [image, setImage],
        maskImg: [maskImg, setMaskImg],
        segmentedImage: [segmentedImage, setSegmentedImage],
        isBrushing: [isBrushing, setIsBrushing],
        allThingmoji: [allThingmoji, setAllThingmoji],
        message:[message,setMessage],
        thingmoji: [thingmoji, setThingmoji],
        intervalthingmoji: intervalthingmoji
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
